import { render } from "./TheClientNavbar.vue?vue&type=template&id=592823d0&scoped=true"
import script from "./TheClientNavbar.vue?vue&type=script&lang=js"
export * from "./TheClientNavbar.vue?vue&type=script&lang=js"

import "./TheClientNavbar.vue?vue&type=style&index=0&id=592823d0&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\PLATEFORME-AUTO-PREFEREPLUS\\paprep-spa\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-592823d0"]])

export default __exports__